import {ACTIVE_DEVELOPMENT_TAGS, ACTIVE_EXPERIMENTAL_TAGS} from '@/lib/constants'
import {useAuth} from '@/state/auth'

const useEnabledDevelopmentTags = () => {
  const activeDevelopmentTag = useAuth(state => state.developmentTag)
  const isDevelopmentTagEnabled = useAuth(state => state.isDevelopmentTagEnabled)

  const isGreenPathEnabled = isDevelopmentTagEnabled(ACTIVE_EXPERIMENTAL_TAGS.GREEN_PATH)
  const isAuditsServiceTagEnabled = isDevelopmentTagEnabled(ACTIVE_DEVELOPMENT_TAGS.AUDITS_SERVICE)
  const isRiskAnalysisTagEnabled = isDevelopmentTagEnabled(ACTIVE_EXPERIMENTAL_TAGS.RISK_ANALYSIS_SERVICE)
  // You can add your platform feature here as well if you want
  // so we all can benefit from this hook.

  const isTracingOperationsAnalyticsTagEnabled = isDevelopmentTagEnabled(
    ACTIVE_DEVELOPMENT_TAGS.TRACING_OPERATIONS_ANALYTICS
  )
  const isTracingComplianceAnalyticsTagEnabled = isDevelopmentTagEnabled(
    ACTIVE_DEVELOPMENT_TAGS.TRACING_COMPLIANCE_ANALYTICS
  )
  const isCertificatesAnalyticsTagEnabled = isDevelopmentTagEnabled(ACTIVE_DEVELOPMENT_TAGS.CERTIFICATES_ANALYTICS)
  const isAuditsAnalyticsTagEnabled = isDevelopmentTagEnabled(ACTIVE_DEVELOPMENT_TAGS.AUDITS_ANALYTICS)

  return {
    activeDevelopmentTag,
    isGreenPathEnabled,
    isDevelopmentTagEnabled,
    isAuditsServiceTagEnabled,
    isRiskAnalysisTagEnabled,
    isTracingOperationsAnalyticsTagEnabled,
    isTracingComplianceAnalyticsTagEnabled,
    isCertificatesAnalyticsTagEnabled,
    isAuditsAnalyticsTagEnabled,
  }
}

export default useEnabledDevelopmentTags
